import { useState, useEffect } from 'react'
import keys from 'lodash/keys'
import compact from 'lodash/compact'
import { PropertiesOptions } from 'src/types/Main'
import CheckIcon from 'src/static/icons/ico_check.svg'
import { translateString } from '../../../../utils/translateString'

interface Props {
  propertyType: string;
  filter: PropertiesOptions;
  filteredProperties: Record<string, string[]>;
  setFilteredProperties(properties: Record<string, string[]>): void;
  filterOnClick: boolean;
}

const ListValue = (props: Props) => {
  const {
    propertyType,
    filter,
    filteredProperties,
    setFilteredProperties
  } = props

  const [selected, setSelected] = useState(
    keys(filteredProperties).some(
      (tagId) => {
        return tagId === propertyType && filteredProperties[tagId].some((tagName) => tagName === filter.value)
      }
    )
  )

  const handlesFilter = async (value: string) => {
    if (selected) {
      filteredProperties[propertyType].splice(filteredProperties[propertyType].indexOf(value), 1)
      setFilteredProperties({
        ...filteredProperties,
        [propertyType]: filteredProperties[propertyType]
      })
    } else {
      setFilteredProperties({
        ...filteredProperties,
        [propertyType]: compact([value].concat(filteredProperties[propertyType]))
      })
    }
    setSelected(!selected)
  }

  useEffect(() => {
    setSelected(
      keys(filteredProperties).some(
        (tagId) => {
          return tagId === propertyType && filteredProperties[tagId].some((tagName) => tagName === filter.value)
        }
      )
    )
  }, [filteredProperties])

  return (
    <div
      className={`list-value-container ${
        selected ? 'label-selected' : ''
      }`}
      onClick={() => handlesFilter(filter.value)}
    >
      <div className="list-value-image">
        {selected && <img src={CheckIcon} />}
      </div>
      <div className="list-value-text">
        <span>
          {translateString(filter.value)}
          <span className='list-value-count'>
            {filter.count}
          </span>
        </span>
      </div>
    </div>
  )
}

export default ListValue
